// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file external/v1/mtm.proto (package external.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file external/v1/mtm.proto.
 */
export const file_external_v1_mtm: GenFile = /*@__PURE__*/
  fileDesc("ChVleHRlcm5hbC92MS9tdG0ucHJvdG8SC2V4dGVybmFsLnYxIogBCgdEZWFsTVRNEhgKEHBsYXRmb3JtX2RlYWxfaWQYASABKAkSIQoEbGVncxgCIAMoCzITLmV4dGVybmFsLnYxLkxlZ01UTRItCg5kZWFsX210bV90b3RhbBgDIAEoCzIQLmV4dGVybmFsLnYxLk1UTUgAiAEBQhEKD19kZWFsX210bV90b3RhbCJlCgZMZWdNVE0SGAoQcGxhdGZvcm1fZGVhbF9pZBgBIAEoCRIOCgZsZWdfaWQYAiABKAkSMQoMdHJhbnNhY3Rpb25zGAMgAygLMhsuZXh0ZXJuYWwudjEuVHJhbnNhY3Rpb25NVE0iUwoOVHJhbnNhY3Rpb25NVE0SFgoOdHJhbnNhY3Rpb25faWQYASABKAkSKQoPdHJhbnNhY3Rpb25fbXRtGAIgAygLMhAuZXh0ZXJuYWwudjEuTVRNIsoBCgNNVE0SKgoKeWVhcl9tb250aBgBIAEoCzIWLmV4dGVybmFsLnYxLlllYXJNb250aBIuChBwcmljZV9kaWZmZXJlbmNlGAIgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbBIjCgVnb29kcxgDIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWwSQgoXZGFpbHlfcHJpY2VfZGlmZmVyZW5jZXMYBCADKAsyIS5leHRlcm5hbC52MS5EYWlseVByaWNlRGlmZmVyZW5jZSKgAQoURGFpbHlQcmljZURpZmZlcmVuY2USHwoEZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSNwoRc2V0dGxlbWVudF9wcmljZXMYAiADKAsyHC5leHRlcm5hbC52MS5TZXR0bGVtZW50UHJpY2USLgoQcHJpY2VfZGlmZmVyZW5jZRgDIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWwiRAoPU2V0dGxlbWVudFByaWNlEgwKBGhvdXIYASABKA0SIwoFcHJpY2UYAiABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsIigKCVllYXJNb250aBIMCgR5ZWFyGAEgASgNEg0KBW1vbnRoGAIgASgNQrIBCg9jb20uZXh0ZXJuYWwudjFCCE10bVByb3RvUAFaSGdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by9leHRlcm5hbC92MTtleHRlcm5hbKICA0VYWKoCC0V4dGVybmFsLlYxygILRXh0ZXJuYWxcVjHiAhdFeHRlcm5hbFxWMVxHUEJNZXRhZGF0YeoCDEV4dGVybmFsOjpWMWIGcHJvdG8z", [file_google_type_date, file_google_type_decimal]);

/**
 * @generated from message external.v1.DealMTM
 */
export type DealMTM = Message<"external.v1.DealMTM"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;

  /**
   * @generated from field: repeated external.v1.LegMTM legs = 2;
   */
  legs: LegMTM[];

  /**
   * @generated from field: optional external.v1.MTM deal_mtm_total = 3;
   */
  dealMtmTotal?: MTM;
};

/**
 * Describes the message external.v1.DealMTM.
 * Use `create(DealMTMSchema)` to create a new message.
 */
export const DealMTMSchema: GenMessage<DealMTM> = /*@__PURE__*/
  messageDesc(file_external_v1_mtm, 0);

/**
 * @generated from message external.v1.LegMTM
 */
export type LegMTM = Message<"external.v1.LegMTM"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;

  /**
   * @generated from field: string leg_id = 2;
   */
  legId: string;

  /**
   * @generated from field: repeated external.v1.TransactionMTM transactions = 3;
   */
  transactions: TransactionMTM[];
};

/**
 * Describes the message external.v1.LegMTM.
 * Use `create(LegMTMSchema)` to create a new message.
 */
export const LegMTMSchema: GenMessage<LegMTM> = /*@__PURE__*/
  messageDesc(file_external_v1_mtm, 1);

/**
 * @generated from message external.v1.TransactionMTM
 */
export type TransactionMTM = Message<"external.v1.TransactionMTM"> & {
  /**
   * @generated from field: string transaction_id = 1;
   */
  transactionId: string;

  /**
   * @generated from field: repeated external.v1.MTM transaction_mtm = 2;
   */
  transactionMtm: MTM[];
};

/**
 * Describes the message external.v1.TransactionMTM.
 * Use `create(TransactionMTMSchema)` to create a new message.
 */
export const TransactionMTMSchema: GenMessage<TransactionMTM> = /*@__PURE__*/
  messageDesc(file_external_v1_mtm, 2);

/**
 * @generated from message external.v1.MTM
 */
export type MTM = Message<"external.v1.MTM"> & {
  /**
   * @generated from field: external.v1.YearMonth year_month = 1;
   */
  yearMonth?: YearMonth;

  /**
   * @generated from field: google.type.Decimal price_difference = 2;
   */
  priceDifference?: Decimal;

  /**
   * @generated from field: google.type.Decimal goods = 3;
   */
  goods?: Decimal;

  /**
   * @generated from field: repeated external.v1.DailyPriceDifference daily_price_differences = 4;
   */
  dailyPriceDifferences: DailyPriceDifference[];
};

/**
 * Describes the message external.v1.MTM.
 * Use `create(MTMSchema)` to create a new message.
 */
export const MTMSchema: GenMessage<MTM> = /*@__PURE__*/
  messageDesc(file_external_v1_mtm, 3);

/**
 * @generated from message external.v1.DailyPriceDifference
 */
export type DailyPriceDifference = Message<"external.v1.DailyPriceDifference"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: repeated external.v1.SettlementPrice settlement_prices = 2;
   */
  settlementPrices: SettlementPrice[];

  /**
   * @generated from field: google.type.Decimal price_difference = 3;
   */
  priceDifference?: Decimal;
};

/**
 * Describes the message external.v1.DailyPriceDifference.
 * Use `create(DailyPriceDifferenceSchema)` to create a new message.
 */
export const DailyPriceDifferenceSchema: GenMessage<DailyPriceDifference> = /*@__PURE__*/
  messageDesc(file_external_v1_mtm, 4);

/**
 * @generated from message external.v1.SettlementPrice
 */
export type SettlementPrice = Message<"external.v1.SettlementPrice"> & {
  /**
   * 0-23
   *
   * @generated from field: uint32 hour = 1;
   */
  hour: number;

  /**
   * @generated from field: google.type.Decimal price = 2;
   */
  price?: Decimal;
};

/**
 * Describes the message external.v1.SettlementPrice.
 * Use `create(SettlementPriceSchema)` to create a new message.
 */
export const SettlementPriceSchema: GenMessage<SettlementPrice> = /*@__PURE__*/
  messageDesc(file_external_v1_mtm, 5);

/**
 * @generated from message external.v1.YearMonth
 */
export type YearMonth = Message<"external.v1.YearMonth"> & {
  /**
   * @generated from field: uint32 year = 1;
   */
  year: number;

  /**
   * @generated from field: uint32 month = 2;
   */
  month: number;
};

/**
 * Describes the message external.v1.YearMonth.
 * Use `create(YearMonthSchema)` to create a new message.
 */
export const YearMonthSchema: GenMessage<YearMonth> = /*@__PURE__*/
  messageDesc(file_external_v1_mtm, 6);

